import React, { useEffect, useState } from "react";
import { FaLink, FaTimes } from "react-icons/fa";
import { LiaRupeeSignSolid } from "react-icons/lia";
import Loading from "../components/Loading";
import { Link } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";

const MakePayment = () => {
  const { token } = useSelector((state) => state.token);
  const { url, user } = useSelector((state) => state.user);
  //
  const [loading, setLoading] = useState(true);
  const [payments, setPayments] = useState([]);
  const [paymentSent, setPaymentSent] = useState([]);
  const [paymentDone, setPaymentDone] = useState([]);
  const [paymentDue, setPaymentDue] = useState("");
  const fetchPayment = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Invoice_Payment/search?criteria=((Lead_Name:equals:${user.id}))`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        }
      );
      //
      if (res.status === 200) {
        setPaymentDue(res.data.data[0].Due_Date);
        res.data.data.map((item) => {
          if (item.Status === null) {
            item.color = "black";
          } else if (item.Status.toLowerCase() === "paid") {
            item.color = "green";
          } else if (
            item.Status.toLowerCase() === "overdue" ||
            item.Status.toLowerCase() === "void"
          ) {
            item.color = "red";
          } else if (item.Status.toLowerCase() === "sent") {
            item.color = "orange";
          } else if (
            item.Status.toLowerCase() === "draft" ||
            item.Status.toLowerCase() === "partially paid"
          ) {
            item.color = "blue";
          }
        });
        res.data.data.forEach((item) => {
          Object.keys(item).forEach((key) => {
            if (item[key] === null) {
              item[key] = "-";
            }
          });
        });
        const paid = res.data.data.filter((item) => {
          return item.Status.toLowerCase() === "paid";
        });
        const unpaid = res.data.data.filter((item) => {
          return item.Status.toLowerCase() !== "paid";
        });
        setPaymentDone(paid);
        setPaymentSent(unpaid);
        setPayments(res.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPayment();
  }, []);
  //
  const [modalVisible, setModalVisible] = useState(false);
  const [paymentDetail, setPaymentDetail] = useState(null);
  const openModal = (item) => {
    setModalVisible(true);
    setPaymentDetail(item);
  };
  const closeModal = () => {
    setModalVisible(false);
    setPaymentDetail(null);
  };
  //
  const [paidActive, setPaidActive] = useState(true);
  return (
    <>
      <div className="container p-2">
        <div className="text-center mt-4">
          <h2>Make a payment</h2>
        </div>

        <div className="bottom-border">
          <h3 className="mb-3">Your payments</h3>
          <p className="mb-2">
            Your monthly payments under PDP is{" "}
            <span className="fw-bold">
              <LiaRupeeSignSolid />
              {user !== null
                ? user.Disposable_Income_DI.toLocaleString("en-IN")
                : ""}
            </span>{" "}
            due on{" "}
            <span className="fw-bold">
              {paymentDue.split("-").reverse().join("-")}
            </span>
            .
          </p>
        </div>

        <div className="w-100">
          {loading ? (
            <Loading />
          ) : payments.length === 0 ? (
            <p className="text-center my-4">No data found</p>
          ) : (
            <div>
              <div className="ticket-tabs">
                <button
                  className={paidActive ? "button" : "white-button"}
                  onClick={() => setPaidActive(true)}
                >
                  <h2>Paid</h2>
                </button>
                <button
                  className={!paidActive ? "button" : "white-button"}
                  onClick={() => setPaidActive(false)}
                >
                  <h2>Unpaid</h2>
                </button>
              </div>
              {paidActive ? (
                <div className="new-grid">
                  {paymentDone.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="new-card"
                        onClick={() => openModal(item)}
                        style={{
                          cursor: "pointer",
                          borderLeft: `5px solid ${item.color}`,
                        }}
                      >
                        <p>
                          <span className="fw-bold">Payment number:</span>{" "}
                          {item.Payment_Number}
                        </p>
                        <p>
                          <span className="fw-bold">Payment date:</span>{" "}
                          {item.Payment_Date !== null
                            ? item.Payment_Date.split("-").reverse().join("-")
                            : "-"}
                        </p>
                        <p>
                          <span className="fw-bold">Grand total:</span>{" "}
                          <LiaRupeeSignSolid />
                          {item.Grand_Total
                            ? item.Grand_Total.toLocaleString("en-IN")
                            : "-"}
                        </p>
                        <p>
                          <span className="fw-bold">creditor amount:</span>{" "}
                          <LiaRupeeSignSolid />
                          {item.Creditors_Amount
                            ? item.Creditors_Amount.toLocaleString("en-IN")
                            : "-"}
                        </p>
                        <p>
                          <span className="fw-bold">Payment status:</span>{" "}
                          <span>{item.Status}</span>
                        </p>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="new-grid">
                  {paymentSent.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="new-card"
                        onClick={() => openModal(item)}
                        style={{
                          cursor: "pointer",
                          borderLeft: `5px solid ${item.color}`,
                        }}
                      >
                        <p>
                          <span className="fw-bold">Payment number:</span>{" "}
                          {item.Payment_Number}
                        </p>
                        <p>
                          <span className="fw-bold">Payment date:</span>{" "}
                          {item.Payment_Date !== null
                            ? item.Payment_Date.split("-").reverse().join("-")
                            : "-"}
                        </p>
                        <p>
                          <span className="fw-bold">Grand total:</span>{" "}
                          <LiaRupeeSignSolid />
                          {item.Grand_Total
                            ? item.Grand_Total.toLocaleString("en-IN")
                            : "-"}
                        </p>
                        <p>
                          <span className="fw-bold">creditor amount:</span>{" "}
                          <LiaRupeeSignSolid />
                          {item.Creditors_Amount
                            ? item.Creditors_Amount.toLocaleString("en-IN")
                            : "-"}
                        </p>
                        <p>
                          <span className="fw-bold">Payment status:</span>{" "}
                          <span>{item.Status}</span>
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* modal */}
      <div className={`custom-modal-container ${modalVisible ? "active" : ""}`}>
        <div className="custom-modal-background" onClick={closeModal}></div>
        <div className="custom-modal-box">
          <div className="header p-2">
            <p className="fw-bold text-capitalize">Payment details</p>
            <div style={{ cursor: "pointer" }} onClick={closeModal}>
              <FaTimes />
            </div>
          </div>
          <div className="body p-2">
            {paymentDetail !== null ? (
              <>
                <p>
                  <span className="fw-bold">Invoice date:</span>{" "}
                  {paymentDetail.Invoice_Date.split("-").reverse().join("-")}
                </p>
                <p>
                  <span className="fw-bold">Due date:</span>{" "}
                  {paymentDetail.Due_Date.split("-").reverse().join("-")}
                </p>
                <p>
                  <span className="fw-bold">Payment Status:</span>{" "}
                  <span
                    className="text-capitalize fw-bold"
                    style={{ color: `${paymentDetail.color}` }}
                  >
                    {paymentDetail.Status}
                  </span>
                </p>
                <p>
                  <span className="fw-bold">Payment date:</span>{" "}
                  {paymentDetail.Payment_Date.split("-").reverse().join("-")}
                </p>
                <p>
                  <span className="fw-bold">Grand total:</span>{" "}
                  <LiaRupeeSignSolid />
                  {paymentDetail.Grand_Total.toLocaleString("en-IN")}
                </p>
                <p>
                  <span className="fw-bold">payment made:</span>{" "}
                  <LiaRupeeSignSolid />
                  {paymentDetail.Payment_Date.split("-").reverse().join("-")}
                </p>
                <p>
                  <span className="fw-bold">balance due:</span>{" "}
                  <LiaRupeeSignSolid />
                  {paymentDetail.Balance_Due.toLocaleString("en-IN")}
                </p>
                <p>
                  <span className="fw-bold">creditor amount:</span>{" "}
                  <LiaRupeeSignSolid />
                  {paymentDetail.Creditors_Amount.toLocaleString("en-IN")}
                </p>
                <p>
                  <span className="fw-bold">payment mode:</span>{" "}
                  {paymentDetail.Payment_Mode}
                </p>
                <Link
                  to={paymentDetail.URL_1}
                  target="_blank"
                  className="button d-block mt-2"
                  style={{ width: "fit-content" }}
                >
                  Pay Now <FaLink />{" "}
                </Link>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MakePayment;
